import {A} from 'components/atoms/LinksAndButtons/A';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {Container} from 'components/atoms/Layout/Container';
import {Icon} from 'components/atoms/Media/Icon';
import {P} from 'components/atoms/Text/P';
import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';
import {useMetaStore, selectCookieSettings} from "features/meta/store/useMetaStore";

import { getFormattedMessage } from 'features/services/utils/language-helper';
import {Margin, MarginVariant, HeadlineLevel} from 'features/ui/enums';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    renderOnAccept: React.ReactNode;
}

export const AcceptThirdPartModal: React.FunctionComponent<Props> = ({renderOnAccept}) => {
    const [hasAccepted, setHasAccepted] = useState<boolean>(false);
    const userCookieSettings = useMetaStore(selectCookieSettings);
    const setCookieSettings = useMetaStore((state) => state.setCookieSettings);

    const onAccept = () => {
        setCookieSettings({
            ...userCookieSettings,
            answered: true,
            thirdParty: true,
        });

        setHasAccepted(true);
    };

    if(hasAccepted) return renderOnAccept;

    return (
        <Container className="accept-third-party-modal">
            <Headline level={HeadlineLevel.H3} margin={Margin.L}><FormattedMessage id="jm.components.AcceptThirdPartyModal.header" /></Headline>
            <P center margin={Margin.L} marginVariant={MarginVariant.CENTER}>
                <FormattedMessage id="jm.components.AcceptThirdPartyModal.description" />
            </P>

            <div>
                <Button 
                    onClick={onAccept} 
                    buttonColor={ButtonColor.CTA} 
                    buttonSize={ButtonSize.DEFAULT} 
                    buttonType={ButtonType.DEFAULT} 
                >
                    <FormattedMessage id="jm.components.AcceptThirdPartyModal.agree" />
                </Button>
            </div>

            <div className="accept-third-party-modal__link">
                <A 
                    href="https://policies.google.com/" 
                    target="_blank" 
                    title={getFormattedMessage('jm.components.AcceptThirdPartyModal.googleTerms')} 
                >
                    <FormattedMessage id="jm.components.AcceptThirdPartyModal.googleTerms" /> <Icon name="external-link" size={20} />
                </A>
            </div>
        </Container>
    )
};
